import { Suspense, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

import { useDialog } from "~/src/modules/ui-kit";

import orderingFunctions from "./sort";
import * as S from "./styled";
import useBrandsOfUser from "../../../../../../clients/users/useBrandsOfUser";
import { useBrands } from "../../../../../../modules/shared-entities";
import * as UI from "../../../../../../modules/ui-kit";
import SearchBait from "../../../components/SearchBait";
import Selection from "../../../components/Selection";


export default function BrandsFilter(props) {
    const { disabled, discovery, onChange, value } = props;

    const [Dialog, open] = useDialog();

    const brands = useBrands();

    if (!brands.data) return "loading";

    return (
        <S.Filter>
            <span>Brands</span>
            <Suspense>
                <Selection
                    disabled={ disabled }
                    items={
                        value
                            .map(
                                (brandID) => brands.data.brands.find(
                                    (brand) => brand.id === brandID
                                )
                            )
                            .sort(orderingFunctions.az)
                    }
                    onChange={ onChange }
                />
            </Suspense>
            {
                !disabled && (
                    <S.Button onClick={ open } type="button">[select Brands]</S.Button>
                )
            }
            <S.Dialog as={ Dialog }>
                <BrandSelection
                    discovery={ discovery }
                    onChange={ onChange }
                    value={ value }
                />
            </S.Dialog>
        </S.Filter>
    );
}

function BrandSelection(props) {
    const { children, discovery, onChange, value } = props;

    const brands = useBrands();

    const allowedBrands = useBrandsOfUser();

    const [ordering, setOrdering] = useState("az");
    const [token, setToken] = useState("");

    if (!discovery) return "loading";
    if (!brands.data) return "loading";

    function toggle(brandID) {
        onChange(
            (brandIDs) => brandIDs.includes(brandID)
                ? brandIDs.filter(
                    (x) => x !== brandID
                )
                : [...brandIDs, brandID]
        );
    }

    const items = brands
        .data
        .brands
        .filter(
            (brand) => allowedBrands.includes(brand.id) || allowedBrands.includes("*")
        )
        .map(
            (brand) => (
                {
                    ...brand,
                    count: discovery
                        .find(
                            (brandScan) => brandScan.brand === brand.legacyID
                        )
                        ?.count ?? 0,
                }
            )
        )
        .filter(
            (brand) => brand.name.toLowerCase().includes(token.toLowerCase()) || brand.id === token
        )
        .sort(orderingFunctions[ordering]);

    const filteredSelected = items.filter((brand) => value.includes(brand.id));
    const filteredOther = items.filter((brand) => !value.includes(brand.id));

    function brandRow(brand) {
        return (
            <tr
                key={ brand.id }
                onClick={ () => toggle(brand.id) }
            >
                <td>{ brand.name }</td>
                <td>{ brand.count }</td>
            </tr>
        );
    }

    return (
        <S.Selection>
            <SearchBait>
                <div>
                    <input
                        onChange={ (event) => setToken(event.target.value) }
                        placeholder="Search"
                        type="text"
                        value={ token }
                    />
                    {
                        token && (
                            <button
                                onClick={ () => setToken("") }
                                type="reset"
                            >
                                <IoClose />
                            </button>
                        )
                    }
                </div>
                <span>search Brands by name</span>
            </SearchBait>
            <S.Table
                $hideHeaders={ filteredSelected.length === 0 || filteredOther.length === 0 }
            >
                <thead>
                    <tr>
                        <th>
                            <button onClick={ () => setOrdering(ordering === "az" ? "za" : "az") }>
                                Name
                                <UI.OrderIcon order={ { az: "ASC", za: "DESC" }[ordering] } />
                            </button>
                        </th>
                        <th>
                            <button onClick={ () => setOrdering(ordering === "90" ? "09" : "90") }>
                                # of products
                                <UI.OrderIcon order={ { "09": "ASC", 90: "DESC" }[ordering] } />
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th colSpan={ 2 }>
                            <FaAngleDown />
                            Selected
                            <span>({ filteredSelected.length })</span>
                        </th>
                    </tr>
                    { filteredSelected.map(brandRow) }
                </tbody>
                <tbody>
                    <tr>
                        <th colSpan={ 2 }>
                            <FaAngleDown />
                            Other
                            <span>({ filteredOther.length })</span>
                        </th>
                    </tr>
                    { filteredOther.map(brandRow) }
                </tbody>
            </S.Table>
            { children }
        </S.Selection>
    );
}
